import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import {
    useQueryClient,
    useMutation,
    MutationFunction,
    UseMutationResult,
} from 'react-query';
import { AxiosResponse } from 'axios';
import { useAlert } from 'core/contexts';
import { commonShowAlert } from 'lib';
interface PutSmartContractProps {
    sdoId: string;
    smartContract: any;
    chain: string;
    token: string;
}

interface PostSmartContractProps {
    smartContract: any;
    chain: string;
    token: string;
}

export const postSmartContract: MutationFunction<
    AxiosResponse<any>,
    PostSmartContractProps
> = (props: PostSmartContractProps) => {
    const headers = getDefaultHeaders(props.token);
    const url = `/graphchain/${props.chain}/smartcontracts`;

    return axiosInstance().post(url, props.smartContract, withHeaders(headers));
};

export const putSmartContract = (
    props: PutSmartContractProps
): Promise<AxiosResponse<any>> => {
    const headers = getDefaultHeaders(props.token);
    const url = `/graphchain/${props.chain}/smartcontracts/${props.sdoId}`;

    return axiosInstance().put(url, props.smartContract, withHeaders(headers));
};

export const useCreateSmartContract = (): UseMutationResult<
    AxiosResponse<any>,
    unknown,
    PostSmartContractProps
> => {
    const queryClient = useQueryClient();
    const { showAlert, hideAlert, showErrorDetails } = useAlert();

    return useMutation(postSmartContract, {
        onSuccess: () => {
            queryClient.invalidateQueries('smart-contracts');
            commonShowAlert(
                showAlert,
                hideAlert,
                'success',
                'Smart Contract Created'
            );
        },
        onError: (error: any) => {
            const errorMessage: string =
                error?.data?.message ?? 'Unable to create smart contract';
            commonShowAlert(
                showAlert,
                hideAlert,
                'error',
                errorMessage,
                JSON.stringify(error?.data ?? ''),
                showErrorDetails
            );
        },
    });
};

export const useUpdateSmartContract = (): UseMutationResult<
    AxiosResponse<any>,
    unknown,
    PutSmartContractProps
> => {
    const queryClient = useQueryClient();
    const { showAlert, hideAlert, showErrorDetails } = useAlert();

    return useMutation(putSmartContract, {
        onSuccess: () => {
            queryClient.invalidateQueries('smart-contracts');
            commonShowAlert(
                showAlert,
                hideAlert,
                'success',
                'Smart contract updated'
            );
        },
        onError: (error: any) => {
            const errorMessage: string =
                error?.data?.message ?? 'Unable to update smart contract';
            commonShowAlert(
                showAlert,
                hideAlert,
                'error',
                errorMessage,
                JSON.stringify(error?.data ?? ''),
                showErrorDetails
            );
        },
    });
};
